export const MAX_POSSIBLE_STAKE_PRICE = 1_000_000_000;
export const MIN_POSSIBLE_STAKE_PRICE = 0;

export const MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES = 0;

export const MAX_PRICE_NUMBER_OF_DECIMAL_PLACES = 2;
